import Modal from "@/components/common/modal/Modal";
import {MediaSelect} from "@/components/organisms";

interface IProps {
  modalOpen: boolean;
  setModalOpen: (modalOpen: boolean) => void;
}

const MediaSelectModal = (props: IProps) => {
  const {modalOpen, setModalOpen } = props;

  return (
    <>
      {
        modalOpen &&
          <Modal setModalOpen={setModalOpen} position='bottom'>
              <MediaSelect setModalOpen={setModalOpen} />
          </Modal>
      }
    </>
  )
}

export default MediaSelectModal;